import { ErrorWithCode } from '@vista-digital/utilities';
/**
 * Domain error definition shared by all domain services when there was a problem processing a request.
 * T is the domain error code enum
 * U is the error data type
 */
export class DomainError extends ErrorWithCode {
    // TODO: Investigate a way to simplify domain error handling. #286495
    constructor(errorCode, errorCodeDescription, errorData, ...params) {
        super(errorCode, ...params);
        this.errorCodeDescription = errorCodeDescription;
        this.errorData = errorData;
        if (params.length === 0) {
            this.message = errorCodeDescription;
        }
        Object.setPrototypeOf(this, DomainError.prototype);
    }
}
//# sourceMappingURL=domain-error.js.map